import { render } from 'preact';
import './ui/tokens.css';
import './ui/app.css';
import { App } from './ui/App';

const root = document.getElementById('app')!;
// Pre-rendered card pages (F18) put readable HTML in #app for no-JS readers and crawlers; the app replaces it.
root.textContent = '';
render(<App />, root);

// Offline support (F12). Dev builds skip the service worker so hot reload stays predictable.
if (import.meta.env.PROD) void import('./pwa/register').then((m) => m.startPwa());
